import React from 'react';

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {' '}
            <img src="img/about.jpg" className="img-responsive" alt="" />{' '}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>
                Nduro Kimotho & Company Advocates is a full service law firm
                based in Nairobi Kenya. Our team is dedicated to offering
                practical, innovative, and effective solutions, drawing on our
                expertise in specific legal areas to ensure our clients have
                peace of mind, knowing their matters are thoroughly handled. As
                a multi-disciplinary firm, we provide legal services across a
                variety of sectors. Our clients are at the heart of everything
                we do, and we aim to deliver the highest quality legal services
                at competitive rates, without compromising on exceptional
                customer experience. We are committed to understanding our
                clients' needs and business goals, helping them grow and thrive
                while maximizing their return on investment. The Firm is
                committed to delivering clear, concise, and practical legal
                advice and services with timely, measurable outcomes to support
                our clients' business goals and other objectives. Our innovative
                and pragmatic legal solutions are tailored to meet the unique
                needs of each client’s business
              </p>
              <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : 'loading'}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : 'loading'}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
